import { useParams } from '@tanstack/react-router'

import { JobLogWorkScreen } from '@/screens/JobLogWorkScreen'
import { ServicePageShell } from '@/screens/ServicePageShell'
import { useJobLogWork } from '@/screens/useJobLogWork'

export function JobLogWorkScreenContainer() {
  const serviceId = useParams({ from: '/jobs/$id/logs', select: (p) => p.id })
  const logWork = useJobLogWork(serviceId)

  if (logWork.kind === 'loading') {
    return (
      <div className="bg-slate-50 text-slate-900"><main className="mx-auto max-w-4xl space-y-2 px-4 py-6"><h1 className="text-2xl font-semibold">Job Track Work</h1><p className="text-sm text-slate-600">Loading job…</p></main></div>
    )
  }
  if (logWork.kind === 'error') {
    return (
      <div className="bg-slate-50 text-slate-900"><main className="mx-auto max-w-4xl space-y-2 px-4 py-6"><h1 className="text-2xl font-semibold">Job Track Work</h1><p className="text-sm text-slate-600">Unable to load job right now.</p></main></div>
    )
  }
  if (logWork.kind === 'not_found') {
    return (
      <div className="bg-slate-50 text-slate-900"><main className="mx-auto max-w-4xl space-y-2 px-4 py-6"><h1 className="text-2xl font-semibold">Job Track Work</h1><p className="text-sm text-slate-600">Job not found. Check the link or return to the jobs page.</p></main></div>
    )
  }

  const displayId = logWork.screenProps.publicId ?? logWork.screenProps.id

  return (
    <ServicePageShell
      serviceTypeLabel="Job"
      serviceId={displayId}
      customerName={logWork.screenProps.customerName}
      customerId={logWork.screenProps.customerId}
      customerPublicId={logWork.screenProps.customerPublicId}
      scheduledAtLabel={logWork.screenProps.scheduledAt}
      initialIssue={logWork.screenProps.issueSummary}
      activeTab="logs"
      basePath="/jobs/$id"
      currentStatus={logWork.screenProps.status}
      statusChanges={logWork.screenProps.statusChanges}
      getAuthorDisplayName={logWork.screenProps.getAuthorDisplayName}
    >
      <JobLogWorkScreen {...logWork.screenProps} showHeader={false} />
    </ServicePageShell>
  )
}
